import type { VehiclesLookupResponse } from "../types";

export type VehiclesLookupSelectItem = {
	id: string;
	label: string;
	value: number;
	plate: string;
	brand: string;
	model: string;
};

export const vehiclesLookupMapToSelectItems = (
	vehiclesData: VehiclesLookupResponse[]
): VehiclesLookupSelectItem[] =>
	vehiclesData.map((vehicle) => ({
		id: vehicle.id.toString(),
		plate: vehicle.plate,
		brand: vehicle.brand,
		model: vehicle.model,
		label: `${vehicle.plate} ${vehicle.brand || vehicle.model ? `- ${vehicle.brand} ${vehicle.model}` : ""}`,
		value: vehicle.id,
	})) ?? [];
